import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const Reply = ({ replyUserName, replyMessage }) => {
	// const userId = useSelector((state) => state.auth.userId);
	// const originMessageOwnerName = replyUserId === userId ? "You" : name;
	// const originMessage = replyMessage && "This message was deleted.";

	return (
		<Box sx={{ ml: '-7px', mr: '-7px', mt: '-5px' }}>
			<Stack direction="row" alignItems="center">
				<Box sx={{ width: '100%', maxHeight: '68px', overflow: 'hidden', bgcolor: '#ffffff', borderRadius: '5px', py: '5px', px: '10px' }}>
					<Stack>
						<Typography variant="h5" color="text.primary">
							{replyUserName}
						</Typography>
						<Typography component="span" color="textSecondary" variant="caption">
							{replyMessage}
						</Typography>
					</Stack>
				</Box>
			</Stack>
		</Box>
	);
};

export default Reply;
